/* global Blockly */
import React from 'react';

function trim(str, len) {
    if (str.length <= len) return str;
    let halfLen = Math.floor(len / 2);
    return str.substring(0, halfLen - 2) + "..." + str.substring(str.length - halfLen - 1, str.length);
}

function defineBlock(context) {
    var pages =
        context.pages.length > 1
            ? context.pages.filter(
                  (page) => page && (!page.formId || !page.formId.includes('carouselgroup'))
              )
            : [];

    pages.sort(function (a,b) {
        var aName = a.name;
        var bName = b.name;
        if(a.formName){
            aName = a.formName + aName;
        }
        if(b.formName){
            bName = b.formName + bName;
        }
        return (aName.toLowerCase()>bName.toLowerCase()?1:(-1));
    });

    if (!!context.workflowItems) {
        pages = [...pages, ...context.workflowItems];
    }

    pages = pages.map(function (x) {
        let displayName = x.name;
        if (x.formName) {
            displayName = trim(x.formName, 13) + " > " + trim(x.name, 14);
        } else {
            displayName = trim(displayName, 30);
        }
        return [displayName, x.id];
    });
    
    return {
        init: function () {
            this.appendDummyInput()
                .appendField("navigate to ")
                .appendField(new Blockly.FieldDropdown(pages), "TOPAGE");
            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setColour(Blockly.Msg.APP_ACTIONS_HUE);
            this.setTooltip('Navigate to a new page in the application.');
            this.setHelpUrl(Blockly.BASE_HELP_URL + "#app-actions");
        }
    }
}

function defineGenerators() {
    return {
        "JavaScript": function (block) {
            let toPage = block.getFieldValue('TOPAGE');

            let code = (
                'if (appWidgetMetaData[\'' + toPage + '\']) {\n' +
                'if (appWidgetMetaData[\'' + toPage + '\'].widgetType == "webpage") {\n' +
                'appContextModule.pushIntoNavigationStack(\'' + toPage + '\');\n' +
                'webPageModule.openWebPage(\'' + toPage + '\');\n' +
                '} else {\n' +
                'var navEvent = new navigateEventService();\n' +
                'navEvent.executeNavigate(\'' + toPage + '\');\n' +
                '} }\n'
            )

            return code;
        }
    }
}

const SnapActionNavigate = function (props) {

    let name = "snap_action_navigate";

    let context = {
        pages: props.context.pages.concat(props.context.webPages),
        workflowItems: props.context.workflowItems
    };

    Blockly.Blocks[name] = defineBlock(context);

    let generators = defineGenerators(context);
    for (let i in generators) {
        Blockly[i][name] = generators[i]
    }

    if (context.pages.length < 2 && (!context.workflowItems || context.workflowItems.length === 0)) {
        return null;
    }

    return (
        <block type={name}></block>
    )
};

export default SnapActionNavigate
